import {RegistrationElements} from "domain/Registerv2/RegistrationElements";
import StepQuestion from "components/Step/StepQuestion";
import React, {Fragment} from "react";
import ContactDetails from "views/Unauthenticated/Registerv2/Steps/ContactDetails";


export default class NotRedeemableStep extends React.Component {
    render() {
        let redeemableResponse = this.props.redeemableResponse;
        let message;
        let message2;
        if (redeemableResponse["transactionId"]) {
            message = redeemableResponse.message;
            message2 = "";
        } else {
            message = "An unexpected error occurred looking up your transaction."
            message2 = redeemableResponse.errors || redeemableResponse.message;
        }

        return <Fragment>
            <StepQuestion>
                Hi {this.props[RegistrationElements.FIRST_NAME]},
                <br/><br/>
                {message}
                <br/><br/>
                {message2 && <Fragment>
                    <i>"{message2}"</i>
                    <br/><br/>
                </Fragment>}
                <ContactDetails
                    emailAddress={this.props.emailAddress}
                />
            </StepQuestion>
        </Fragment>
    }
}